import React from 'react';
import { Chip } from '@mui/material';
import { CHANNEL_COLOR_PALETTE } from '../utils/channelColors';

function hashString(str) {
  let h = 0;
  if (!str) return 0;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h) + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

// Fallback when channel has no color (stable per channel via hash)
function getFallbackColor(channel) {
  if (!channel) return CHANNEL_COLOR_PALETTE[0];
  const seed = (channel.id || '') + (channel.name || '');
  const idx = hashString(seed) % CHANNEL_COLOR_PALETTE.length;
  return CHANNEL_COLOR_PALETTE[idx];
}

function isLight(hex) {
  if (!hex || hex.length < 6) return false;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5;
}

/**
 * Renders a channel as a small colored badge (Chip).
 * @param {object} props
 * @param {object} [props.channel] - { name, color?, id? }
 * @param {string} [props.name] - use when channel object not available
 * @param {string} [props.color] - use when channel object not available
 * @param {string} [props.size] - 'small' | 'medium'
 */
function ChannelBadge({ channel, name, color, size = 'small', ...chipProps }) {
  const label = channel?.name ?? name ?? '';
  const bgColor = (channel?.color || color || '').trim() || getFallbackColor(channel || { id: '', name });
  const textColor = isLight(bgColor) ? '#1a1a1a' : '#fff';

  if (!label) return null;

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: 600,
        '& .MuiChip-label': { px: 1.25 },
      }}
      {...chipProps}
    />
  );
}

export default ChannelBadge;
